import React, { useState, useEffect } from 'react';
import { Table, Input, Button, Row, Col, Card, Statistic, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../utils/api';

function ApiCallLogs() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [summary, setSummary] = useState({ total_count: 0, total_followers: 0, total_cost: 0 });

  const loadData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, pageSize: 50 };
      if (keyword) params.keyword = keyword;
      const res = await api.get('/api-configs/call-logs', { params });
      if (res.code === 200) {
        setData(res.data.list);
        setTotal(res.data.total);
        setPage(p);
        setSummary(res.data.summary || { total_count: 0, total_followers: 0, total_cost: 0 });
      }
    } catch (err) {}
    setLoading(false);
  };

  useEffect(() => { loadData(); }, []);

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '接口名称', dataIndex: 'config_name', width: 130 },
    { title: '抖音号', dataIndex: 'account_name', width: 140 },
    {
      title: '粉丝数', dataIndex: 'follower_count', width: 100, align: 'right',
      render: v => v != null ? <Tag color="blue">{v}</Tag> : '-'
    },
    {
      title: '消费', dataIndex: 'cost', width: 100, align: 'right',
      render: v => v != null ? `¥${Number(v).toFixed(4)}` : '-'
    },
    {
      title: '余额', dataIndex: 'balance', width: 100, align: 'right',
      render: v => v != null ? `¥${Number(v).toFixed(4)}` : '-'
    },
    {
      title: '备注', dataIndex: 'remark', width: 200, ellipsis: true,
      render: v => v || '-'
    },
    {
      title: '调用时间', dataIndex: 'created_at', width: 170,
      render: v => v ? dayjs(v).format('YYYY-MM-DD HH:mm:ss') : '-'
    }
  ];

  return (
    <div>
      <h3 style={{ margin: '0 0 16px 0' }}>调用记录</h3>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={8}>
          <Card size="small"><Statistic title="调用次数" value={summary.total_count} /></Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card size="small"><Statistic title="粉丝数汇总" value={summary.total_followers} /></Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card size="small"><Statistic title="消费汇总" value={Number(summary.total_cost).toFixed(4)} prefix="¥" /></Card>
        </Col>
      </Row>
      <div style={{ marginBottom: 16, display: 'flex', gap: 12 }}>
        <Input
          placeholder="搜索抖音号"
          prefix={<SearchOutlined />}
          value={keyword}
          onChange={e => setKeyword(e.target.value)}
          onPressEnter={() => loadData(1)}
          style={{ width: 250 }}
          allowClear
        />
        <Button type="primary" icon={<SearchOutlined />} onClick={() => loadData(1)}>搜索</Button>
      </div>
      <Table
        rowKey="id" columns={columns} dataSource={data} loading={loading}
        pagination={{ current: page, pageSize: 50, total, onChange: loadData }}
        size="small" scroll={{ x: 700 }}
      />
    </div>
  );
}

export default ApiCallLogs;
